import { factory } from '@wix/web-bi-logger'

const getESI = () => {
  const searchParams = new URLSearchParams(window.location.search)
  // TODO: Is this the right way to get ESI?
  return searchParams.get('esi')
}

const getScreenResolution = () => {
  const { availWidth, availHeight } = window.screen
  return `${availWidth}x${availHeight}`
}

const getDefaults = () => ({
  view: 'intro.category-search',
  screenResolution: getScreenResolution(),
  adiBuilderType: 'desktop',
  flow: 'main funnel',
  esi: getESI(),
})

const logger = factory().logger()

type OnboardingPageViewParams = {
  contentLanguage?: string
}

export const onboardingPageView = (params: OnboardingPageViewParams) => {
  return logger.report({
    src: 66,
    evid: 100,
    endpoint: 'onboarding',
    params: {
      ...getDefaults(),
      isFake: false,
      referral: '',
      ...params,
    },
  })
}

type OnboardingSelectedParams = {
  name: string
  text: string
  position: number
  suggestList: string
}

export const onboardingSelected = (params: OnboardingSelectedParams) => {
  return logger.report({
    src: 66,
    evid: 101,
    endpoint: 'onboarding',
    params: {
      ...getDefaults(),
      ...params,
    },
  })
}

type OnboardingTypingParams = {
  text: string
  returnedResults: number
  contentLanguage?: string
}

export const onboardingTyping = (params: OnboardingTypingParams) => {
  return logger.report({
    src: 66,
    evid: 102,
    endpoint: 'onboarding',
    params: {
      ...getDefaults(),
      ...params,
    },
  })
}

type OnboardingAnswerParams = {
  contentLanguage?: string
  name: string
  navButton: 'next' | 'skip'
  selectedIndustryId: string
  selectedStructureId: string
  suggestList: string
  text: string
}

export const onboardingAnswer = (params: OnboardingAnswerParams) => {
  return logger.report({
    src: 66,
    evid: 103,
    endpoint: 'onboarding',
    params: {
      ...getDefaults(),
      isFake: false,
      ...params,
    },
  })
}
